import React from 'react';

function formatAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toLocaleString('en-US', { maximumFractionDigits: 2 }) : String(value || '0');
}

export default function EscrowTermsMessage({ terms }) {
  const data = terms || {};
  const steps = [
    `The buyer pays the cost of the channel +${data.serviceFeeRange || '4-8'}% ($${data.minFee ?? 3} minimum) service fee.`,
    'The seller designates the escrow agent as owner.',
    'The escrow agent verifies everything and assigns manager rights to the buyer.',
    `After ${data.holdDays ?? 7} days, the escrow agent removes all the other managers and assigns primary ownership rights to the buyer (${data.holdDays ?? 7} days is the minimum amount of time required in order to assign a new primary owner in the control panel.)`,
    'We send the funds to the seller. Money is sent instantly through all payment systems.'
  ];

  return (
    <div className="escrow-terms-message">
      <div className="escrow-terms-heading">Request to purchase “{data.channelName || 'Channel'}”</div>
      <div className="escrow-terms-parties">
        {data.buyerHandle || 'Buyer'} <span aria-hidden="true">→</span> {data.sellerName || data.sellerHandle || 'Seller'}
      </div>
      <dl className="escrow-terms-details">
        <div><dt>Transaction ID</dt><dd>{data.transactionId || 'Unavailable'}</dd></div>
        <div><dt>Transaction amount</dt><dd>${formatAmount(data.amount)}</dd></div>
        <div><dt>Transfer to</dt><dd>{data.sellerHandle || 'Unavailable'}</dd></div>
      </dl>
      <div className="escrow-terms-divider" />
      <div className="escrow-terms-label">Transaction steps when using the escrow service</div>
      <ol>{steps.map(step => <li key={step}>{step}</li>)}</ol>
    </div>
  );
}